//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default{
        name:'cfrList',
        data(){
            return{
                nurser_name:[],
                maternal_list:[],//查房人列表
                pinyin_array:[]//查房人列表拼音顺序
            }
        },
        props:{
            list_id:{
                type:String,
                required:true
            },
            showCfrList:{
                type:Boolean,
                required:true
            }
        },
        methods:{
            apiGetCfrList(){
                let params = {
                    token: this.$cookie.get('token'),
                    store_id:this.$cookie.get('store_id'),
                }
                console.log(params)
                Api.checkRoomApi.getCheckInfo(params).then ( res => {
                    console.info("获取查房人列表",res)
                    if(res.errcode == 1){
                        this.nurser_name = res.data.nurser_name//过滤了离院，
                        this.cfr_list(res.data.nurser_name)
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        }) 
                    }
                })
            },
            //组装查房人
            cfr_list(arr){
                if(arr.length){
                    let nurser_name_arr = []
                    for(let item of arr){
                    let _py = ((py.ConvertPinyin(item.user_name)).substr(0, 1)).toUpperCase()            
                    let obj ={
                        name:[item.user_name],
                        pinyin:_py
                    }
                    nurser_name_arr.push(obj)
                    }
                    let pyArr =[]
                    for(let item of nurser_name_arr){
                        let obj ={
                            name:item.name,
                            pinyin:item.pinyin
                        }
                        let is_have = this.isInArray(pyArr,item.pinyin)
                        if(!is_have){
                            //不存在
                            pyArr.push(item.pinyin)  
                            this.pinyin_array.push(item.pinyin) 
                            this.pinyin_array.sort()
                            this.maternal_list.push(obj)
                        }else{
                            //存在
                            let _index = pyArr.indexOf(item.pinyin)
                            this.maternal_list[_index].name.push((item.name).join(''))
                        }
                    }
                    this.maternal_list = this.arrar_sort(pyArr,this.maternal_list)
                    console.info(this.maternal_list)
                }
            },
            //数组排序
            arrar_sort(newArr,oldArr){
                let newList = []
                let pyArrSort = newArr.sort()
                let i=0;
                for(let item of pyArrSort){
                    for(let list of oldArr){
                    if(item == list.pinyin){
                        newList[i] = list
                    }
                    }
                    i++
                }
                return newList
            },

            //判断元素是否在数组上
            isInArray(arr,value){
                for(let item of arr){
                    if(value === item){
                        return true;
                    }
                }
                return false;
            },
            //关闭
            closeCfrList(){
                this.$emit("cfrListEven",false)
            },
            //点击查房人
            selece_cfr(name){
                console.info(this.nurser_name)
                for(let item of this.nurser_name){
                    if(name == item.user_name){
                        this.$emit("cfrListEven",false,item)
                    }
                }
            }
        },
        created(){
            console.info(this.list_id)
            this.apiGetCfrList()
        }
    }



// WEBPACK FOOTER //
// ./src/components/cfrList.vue